import { KeycloakService, PagedResponse } from '@elotech/components';
import axios, { AxiosPromise } from 'axios';

import {
  Cliente,
  DashboardDTO,
  DashboardInfo,
  Entidade,
  EnumDTO,
  ModuloConfig,
  ModuloConfigResume
} from '../type';

const resource = () =>
  `${KeycloakService.getInstance().authServerUrl}/realms/${
    KeycloakService.getInstance().realm
  }/cliente`;

const cliente_api = '/console-api/api/clientes';

const defaultSort = {
  sort: 'nome,asc'
};

export const search = (
  searchParams: string,
  page: any,
  sort = defaultSort
): AxiosPromise<PagedResponse<Cliente>> => {
  return axios.get(`${cliente_api}`, {
    params: { search: searchParams, ...sort, ...page }
  });
};

export const findById = (id: string): AxiosPromise<Cliente> => {
  return axios.get(`${cliente_api}/${id}`);
};

export const save = (cliente: Cliente): AxiosPromise<Cliente> => {
  return cliente.id
    ? axios.put(`${cliente_api}/${cliente.id}`, cliente)
    : axios.post(cliente_api, cliente);
};

export const getInformacoesDashboard = (): AxiosPromise<DashboardDTO> => {
  return axios.get(`${resource()}/dashboard`);
};

export const getModulosConfig = (id: string): AxiosPromise<ModuloConfig[]> =>
  axios.get(`${resource()}/${id}/modulo-config`);

export const getModulosConfigResume = (
  id: string
): AxiosPromise<ModuloConfigResume[]> =>
  axios.get(`${cliente_api}/${id}/modulo-config`);

export const saveModuloConfig = (
  id: string,
  modulos: ModuloConfig[]
): AxiosPromise<ModuloConfig[]> =>
  axios.put(`${cliente_api}/${id}/modulo-config`, modulos);

export const getModulos = (): AxiosPromise<EnumDTO[]> =>
  axios.get(`${resource()}/atual/modulos`);

export const getEntidades = (search: string): AxiosPromise<Entidade[]> =>
  axios.get(`${resource()}/atual/entidades`, {
    params: { search }
  });

export const getContratantes = (): AxiosPromise<string[]> =>
  axios.get(`${resource()}/contratantes`);

export const dashboardInfo = (tenant: string): AxiosPromise<DashboardInfo> =>
  axios.get(`/console-api/api/clientes/dashboard`, {
    params: { tenant: tenant }
  });
